import {
  LFL_DEFAULT_DESCRIPTION,
  LFL_DEFAULT_DESCRIPTION_COLOR,
  LFL_DEFAULT_HEADING_LINE_1,
  LFL_DEFAULT_HEADING_LINE_2,
} from "@/widgets/visionaries/learnFromLeadersCopy";

export const LEARN_FROM_LEADERS_1_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Leader cards",
  },

  DEFAULT_ROW: {
    id: "",
    profile_name: "",
    profile_title: "",
    profile_name_color: "#FFFFFF",
    profile_title_color: "rgba(255,255,255,0.82)",
    show_divider: true,
    desktop_image: "",
    mobile_image: "",
    image_alt: "",
    show_card_overlay_gradient: true,
    card_overlay_gradient_start: "#000000",
    card_overlay_gradient_end: "#00000000",
    card_overlay_gradient_angle: "180deg",
    logo_1: "",
    logo_1_alt: "",
    logo_2: "",
    logo_2_alt: "",
    logos_layout: "row_center",
    priority: 0,
    is_active: true,
  },

  LEARN_FROM_LEADERS_FIELDS_CONFIG: [
    {
      fieldName: "pre_title",
      label: "First headline line",
      value: LFL_DEFAULT_HEADING_LINE_1,
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Learn directly from leaders",
      required: false,
      defaultValue: LFL_DEFAULT_HEADING_LINE_1,
    },
    {
      fieldName: "pre_title_color",
      label: "First line text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Second headline line",
      value: LFL_DEFAULT_HEADING_LINE_2,
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. shaping your industry",
      required: false,
      defaultValue: LFL_DEFAULT_HEADING_LINE_2,
    },
    {
      fieldName: "title_end_color",
      label: "Second line text color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "description",
      label: "Description",
      value: LFL_DEFAULT_DESCRIPTION,
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Body copy below the heading",
      required: false,
      defaultValue: LFL_DEFAULT_DESCRIPTION,
    },
    {
      fieldName: "description_color",
      label: "Description text color",
      value: LFL_DEFAULT_DESCRIPTION_COLOR,
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: LFL_DEFAULT_DESCRIPTION_COLOR,
    },
    {
      fieldName: "desktop_background_color",
      label: "Desktop background color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile background color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "enable_animation",
      label: "Enable animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Name",
      fieldName: "profile_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leader name",
      required: false,
    },
    {
      header: "Title / bio",
      fieldName: "profile_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Role or short bio",
      required: false,
    },
    {
      header: "Name color",
      fieldName: "profile_name_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
    },
    {
      header: "Title color",
      fieldName: "profile_title_color",
      value: "rgba(255,255,255,0.82)",
      valueType: "string",
      filedType: "COLOR",
      required: false,
    },
    {
      header: "Divider",
      fieldName: "show_divider",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/hide the divider line under the name",
      required: false,
    },
    {
      header: "Desktop image",
      fieldName: "desktop_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: true,
    },
    {
      header: "Mobile image",
      fieldName: "mobile_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: false,
    },
    {
      header: "Image alt",
      fieldName: "image_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
    },
    {
      header: "Card overlay gradient",
      fieldName: "show_card_overlay_gradient",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/hide the card overlay gradient",
      required: false,
    },
    {
      header: "Card overlay gradient start",
      fieldName: "card_overlay_gradient_start",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      required: false,
    },
    {
      header: "Card overlay gradient end",
      fieldName: "card_overlay_gradient_end",
      value: "#00000000",
      valueType: "string",
      filedType: "COLOR",
      required: false,
    },
    {
      header: "Card overlay gradient angle",
      fieldName: "card_overlay_gradient_angle",
      value: "180deg",
      valueType: "string",
      filedType: "INPUT",
      required: false,
    },
    {
      header: "Logo 1",
      fieldName: "logo_1",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: false,
    },
    {
      header: "Logo 1 alt",
      fieldName: "logo_1_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
    },
    {
      header: "Logo 2",
      fieldName: "logo_2",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: false,
    },
    {
      header: "Logo 2 alt",
      fieldName: "logo_2_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
    },
    {
      header: "Logos layout",
      fieldName: "logos_layout",
      value: "row_center",
      valueType: "string",
      filedType: "SELECT",
      options: [
        { label: "Row center", value: "row_center" },
        { label: "Stack", value: "stack" },
      ],
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 0,
      valueType: "number",
      filedType: "INPUT",
      required: false,
    },
    {
      header: "Active",
      fieldName: "is_active",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
    },
  ],
};
